import { useRecoilState, useRecoilValue } from "recoil";
import {
  DetailBodyWrapper,
  DetailInfoPopupWrapper,
  DetailItemInputBox,
  DetailItemWrapper,
  EditDetailBottom,
} from "../styles/detailInfo.style";
import { pubState } from "../../../recoil/pub.atom";
import { useState } from "react";
import { sellerPub, updateDetailSellerPub } from "../../../api/cafe";
import { UserState } from "../../../recoil/user.atom";
import { PopupContainer } from "../../../styles/popup";

const DetailInfoPopup = ({
  setIsDetailInfoOpen,
}: {
  setIsDetailInfoOpen: any;
}) => {
  const [pub, setPub] = useRecoilState(pubState);
  const [buyIn, setBuyIn] = useState(pub ? pub.buyIn : 0);
  const [buyInMax, setBuyInMax] = useState(pub ? pub.buyInMax : 0);
  const [blindUp, setBlindUp] = useState(pub ? pub.blindUp : 0);
  const [blindUpMax, setBlindUpMax] = useState(pub ? pub.blindUpMax : 0);
  const [prize, setPrize] = useState(pub ? pub.prize : 0);
  const [prizeMax, setPrizeMax] = useState(pub ? pub.prizeMax : 0);

  const user = useRecoilValue(UserState);

  const getPub = async () => {
    if (!user || !pub) return;
    try {
      const res = await sellerPub(pub.id);
      if (res) {
        setPub(res);
      }
    } catch (e) {}
  };
  const updateDetailInfo = async () => {
    if (!pub) return;
    const request = {
      buyIn,
      buyInMax,
      blindUp,
      blindUpMax,
      prize,
      prizeMax,
      cafeId: pub.id,
    };

    try {
      const res = await updateDetailSellerPub(request);
      if (res) {
        alert("저장에 성공하였습니다.");
        setIsDetailInfoOpen(false);
        await getPub();
      }
    } catch (e) {
      alert("일시적인 네트워크 문제로 잠시 후 다시 시도해주세요.");
    }
  };

  return (
    <PopupContainer>
      <DetailInfoPopupWrapper>
        <div className="header">
          <span>블라인드 타이머 수동 입력</span>
          <img
            src="/image-web/tournament/close.svg"
            onClick={() => {
              setIsDetailInfoOpen(false);
            }}
          />
        </div>
        <DetailBodyWrapper>
          <DetailItemWrapper>
            <div className="title">바이인 금액</div>
            <DetailItemInputBox>
              <input
                placeholder="최소"
                type="number"
                value={buyIn === 0 ? "" : buyIn}
                onChange={(e) => {
                  setBuyIn(+e.target.value);
                }}
              />
            </DetailItemInputBox>
            <DetailItemInputBox>
              <input
                placeholder="최대"
                type="number"
                value={buyInMax === 0 ? "" : buyInMax}
                onChange={(e) => {
                  setBuyInMax(+e.target.value);
                }}
              />
            </DetailItemInputBox>
          </DetailItemWrapper>
          <DetailItemWrapper>
            <div className="title">블라인드 업 타임</div>
            <DetailItemInputBox>
              <input
                placeholder="최소"
                type="number"
                value={blindUp === 0 ? "" : blindUp}
                onChange={(e) => {
                  setBlindUp(+e.target.value);
                }}
              />
            </DetailItemInputBox>
            <DetailItemInputBox>
              <input
                placeholder="최대"
                type="number"
                value={blindUpMax === 0 ? "" : blindUpMax}
                onChange={(e) => {
                  setBlindUpMax(+e.target.value);
                }}
              />
            </DetailItemInputBox>
          </DetailItemWrapper>
          <DetailItemWrapper>
            <div className="title">프라이즈</div>
            <DetailItemInputBox>
              <input
                placeholder="최소"
                type="number"
                value={prize === 0 ? "" : prize}
                onChange={(e) => {
                  setPrize(+e.target.value);
                }}
              />
            </DetailItemInputBox>
            <DetailItemInputBox>
              <input
                type="number"
                placeholder="최대"
                value={prizeMax === 0 ? "" : prizeMax}
                onChange={(e) => {
                  setPrizeMax(+e.target.value);
                }}
              />
            </DetailItemInputBox>
          </DetailItemWrapper>
        </DetailBodyWrapper>
        <EditDetailBottom>
          <div
            className="button"
            onClick={() => {
              updateDetailInfo();
            }}
          >
            저장하기
          </div>
        </EditDetailBottom>
      </DetailInfoPopupWrapper>
    </PopupContainer>
  );
};

export default DetailInfoPopup;
